import Collapse, { collapseProps } from './Collapse';
import CollapsePanel, { collapsePanelProps } from './CollapsePanel';
import CollapseCondition, { collapseConditionProps } from './CollapseCondition';
import CollapseConditionPanel from './CollapseConditionPanel';
// export type { CollapseConditionPanelProps } from './CollapseConditionPanel';
Collapse.Panel = CollapsePanel;
Collapse.Condition = CollapseCondition;
Collapse.ConditionPanel = CollapseConditionPanel;
/* istanbul ignore next */
Collapse.install = function (app) {
    app.component(Collapse.name, Collapse);
    app.component(CollapsePanel.name, CollapsePanel);
    app.component(CollapseCondition.name, CollapseCondition);
    app.component(CollapseConditionPanel.name, CollapseConditionPanel);
    return app;
};
export { CollapsePanel, CollapseCondition, CollapseConditionPanel, collapseProps, collapsePanelProps, collapseConditionProps,
// collapseConditionPanelProps,
 };
export default Collapse;
